import React from "react";
import DataTable from 'react-data-table-component';

export default function SortableTable({
      columns,
      data,
      pagination,
      sortFunction,
      sortServer,
      defaultSortFieldId,
      defaultSortAsc,
      ...rest
  }) {
    return (
        <DataTable
            columns={columns}
            data={data}
            pagination={pagination}
            onSort={sortFunction}
            sortServer={sortServer}
            defaultSortFieldId={defaultSortFieldId}
            defaultSortAsc={defaultSortAsc}
            {...rest}
        />
    );
}